import React from 'react';
import type { FC } from 'react';

import { useNthUserHomeOnboardingTakeoverV2Eligibility } from '../hooks/useNthUserHomeOnboardingTakeoverV2Eligibility.ts';

import { NthUserHomeOnboardingTakeoverV2HomeNudge } from './NthUserHomeOnboardingTakeoverV2HomeNudge.tsx';

type HomeOnboardingTakeoverV2HomeNudgeProps = {
	position?: 'bottom-start' | 'right-start';
	children?: React.ReactNode;
};

export const HomeOnboardingTakeoverV2HomeNudge: FC<HomeOnboardingTakeoverV2HomeNudgeProps> = ({
	children,
}) => {
	const { isEligible: v2NthUserEligible, loading: v2NthUserLoading } =
		useNthUserHomeOnboardingTakeoverV2Eligibility();

	if (v2NthUserLoading) {
		return children;
	}

	if (v2NthUserEligible) {
		return (
			<NthUserHomeOnboardingTakeoverV2HomeNudge position="bottom-start">
				{children}
			</NthUserHomeOnboardingTakeoverV2HomeNudge>
		);
	}

	return children;
};
